import { render, staticRenderFns } from "./orders-list-table-body.component.vue?vue&type=template&id=2c4048ce&scoped=true"
import script from "./orders-list-table-body.component.vue?vue&type=script&lang=js"
export * from "./orders-list-table-body.component.vue?vue&type=script&lang=js"
import style0 from "./orders-list-table-body.component.vue?vue&type=style&index=0&id=2c4048ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4048ce",
  null
  
)

export default component.exports